import e from "./SpecificationExtensions.vue_vue_type_script_setup_true_lang.js";
//#region src/specification-extensions/SpecificationExtensions.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SpecificationExtensions.vue.js.map